export const FOLDERS = 'folders';
export const TAGS = 'tags';
export const COMBINED = 'combined';
